import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { WeekCalendar } from 'src/app/Models/week-calendar';

@Component({
  selector: 'app-week-day-calendar',
  templateUrl: './week-day-calendar.component.html',
  styleUrls: ['./week-day-calendar.component.css']
})
export class WeekDayCalendarComponent implements OnInit,OnChanges {

   weekdays:WeekCalendar[]=[ new WeekCalendar("Sunday"),new WeekCalendar("Monday"),new WeekCalendar("Tuesday"),new WeekCalendar("Wednesday")
  ,new WeekCalendar("Thursday"),new WeekCalendar("Friday"),new WeekCalendar("Saturday")];
  @Input() data:any; 
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    this.doRender();
  }

  ngOnInit(): void {
  }
  @Input()

  set RenderGridColors(activate:boolean)
  {
    this.doRender();
    
    
  }
  doRender()
  {
    this.weekdays=[ new WeekCalendar("Sunday"),new WeekCalendar("Monday"),new WeekCalendar("Tuesday"),new WeekCalendar("Wednesday")
    ,new WeekCalendar("Thursday"),new WeekCalendar("Friday"),new WeekCalendar("Saturday")];
          if(this.data!=undefined)
          {
            for (let index = 0; index < this.data.length; index++) {
              const element = this.data[index];
              let startindex= this.weekdays.findIndex(w=>w.WeekDay.substring(0,2).toUpperCase()==element.BAND_START_DAY)
              let startday=element.BAND_START_DAY+''+element.BAND_START_TIME.Hours.toString();
              let endday=element.BAND_END_DAY+''+element.BAND_END_TIME.Hours.toString();
              let startdayn=element.BAND_START_DAY;
              let starthour=element.BAND_START_TIME.Hours;
                while(startday!=endday)
                {
                  if(this.weekdays[startindex]){
                    if(element.masterParkingRate!=undefined)
                      this.weekdays[startindex]["H"+starthour.toString()].color=element.masterParkingRate.COLOR;
                    else
                      this.weekdays[startindex]["H"+starthour.toString()].color='yellow';
                    starthour++;
                    if(starthour==23)
                    {
                      if(this.weekdays[startindex])
                    startday=this.weekdays[startindex].WeekDay.substring(0,2).toUpperCase()+''+starthour.toString();  
                      if(starthour<=element.BAND_END_TIME.Hours)
                      {
                        if(element.masterParkingRate!=undefined)
                          this.weekdays[startindex]["H"+starthour.toString()].color=element.masterParkingRate.COLOR;
                          else
                          this.weekdays[startindex]["H"+starthour.toString()].color='yellow';
                      starthour=0;
                      startindex++;
                      if(startday==endday)
                          break;
                      }
                    }
                    if(this.weekdays[startindex])
                    startday=this.weekdays[startindex].WeekDay.substring(0,2).toUpperCase()+''+starthour.toString();
                  }
                  else
                  break;
                }
                
              
              
            }
          }
  }
}
